import { useOrganization } from 'context/OrganizationContext';
import React from 'react';

const Footer: React.FC = () => {
  const { currentOrganization } = useOrganization();


  return (
    <div className="text-center text-gray-500 text-sm flex items-center justify-center gap-2" style={{ marginTop: 32, paddingBottom: 32 }}>
      {!currentOrganization?.hide_logo && (<>
        <img
          src="https://cdn.prod.website-files.com/619e5a6e8bd4831f9e3f07ed/683ecbb13daaa36bd475b4c3_HITAI_white.svg"
          alt="HITAI"
          className="h-4"
        />
        <p>StrikeVision v0.2 | AI-Powered Combat Analytics</p>
      </>)}
    </div>
  );
};

export default Footer;